import { Component } from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-contact-list',
  templateUrl: './contact-list.component.html',
  styleUrls: ['./contact-list.component.scss']
})
export class ContactListComponent {

  public dataListing:any=[];
  public AllData:any=[];
  public loading:boolean = true;
  public loginDetail:any =[];
  public totalCount: number = 0;
  public p = 1;
  public pageLimit:any = 10;
  public previousLabel:any='';
  public nextLabel:any='';
  public searchKey:any='';
  public confirmStatus: boolean = false;
  public Ids:any=''; 
  public sortType:any='desc';

  constructor(public router: Router, public service: GlobalService) { 
    this.loginDetail = JSON.parse(localStorage.getItem('gra_login') || "{}");   
    this.getDetail(this.p);
   }

  ngOnInit(): void {
  }

     getDetail(page:any){  
      this.loading= true;  
      var url = `/contact-request?page=${page}`;
      if(this.searchKey !=''){
        url=url+'&search='+this.searchKey;
      }
      url=url+'&sortBy=createdAt'+'&sortOrder='+this.sortType;
      this.service.GetApi(url).subscribe(((response:any)=>{
        if(response.success ==1) {             
          this.dataListing= response.data.record;  
          this.totalCount=response.data.total;
          this.loading=false;
        } else {
          this.dataListing=[];  
          this.loading=false;
        }
      }), (error) => { this.loading =false; });
    }

    updateStatus(data:any){
      if(data.status=="Active"){
        var url='/contact-request-update';
        var detail={
          "status": 1,
          "request_id": data._id,
      }
        this.service.PostApis(detail,url).subscribe(((response:any)=>{
          if(response.success ==1){         
            this.loading=false; 
            this.p=1; 
            this.getDetail(this.p);
          } else {
            this.service.dangerAlert(response.message);
            this.loading=false;
          }
        }), (error:any) => {
          this.loading=false;
        });
      }    
    }

    reset(){
      this.p=1;
      this.searchKey='';
      this.getDetail(this.p);
    }

    remove(data:any){
      var url='/contact-request-delete';
      var detail={
        "request_id": data._id
      }
      this.service.PostApis(detail,url).subscribe(((response:any)=>{
        if(response.success ==1){         
          this.loading=false; 
          this.p=1; 
          this.getDetail(this.p);
        } else {
          this.service.dangerAlert(response.message);
          this.loading=false;
        }
      }), (error:any) => {
        this.loading=false;
      });
    }    
}
